import {
  IS_MULTI_SIGNATORY_ENABLED,
  SUCCESS_API_CODE,
} from "@zenith/data/constants";
import useAppNavigation from "@zenith/hooks/appNavigation";
import {
  BUSINESS_VERIFICATION,
  PROFILE_CREATION,
  SIGN_UP_USER,
} from "@zenith/routes/paths";
import {
  OnboardingApiService,
  OnboardingStepResponseDTO,
} from "@zenith/services/user";
import {
  isMultiSignatoryFlow,
  isPostSubmissionStatus,
} from "@zenith/pages/BusinessRegistrationpage/businessStepUtils";

const { currentStatus: Status } = OnboardingStepResponseDTO;

const BUSINESS_ONBOARDING_STATUSES = new Set<string>([
  Status.PENDING_PERSONAL_DETAILS,
  Status.PENDING_SELFIE_VERIFICATION,
  Status.PENDING_BUSINESS_INFORMATION,
  Status.PENDING_REQUIRED_DOCUMENTS,
  Status.PENDING_PEOPLE,
  Status.PENDING_SET_ACCOUNT,
  "PENDING_SUBMIT",
  "PENDING_PAYOUT_ACCOUNTS",
]);

export const useBusinessRegistrationStatus = () => {
  const { navigateTo } = useAppNavigation();

  const getBusinessRegistrationType = async (userExternalId: string) => {
    try {
      const response = await OnboardingApiService.getRegistrationStatus(
        userExternalId
      );

      if (
        response.success &&
        response.data &&
        response.internalCode === SUCCESS_API_CODE
      ) {
        const { steps, currentStatus, registrationType } = response.data;

        if (currentStatus === Status.PENDING_REGISTRATION_TYPE) {
          navigateTo(PROFILE_CREATION);
          return;
        }

        const isIndividualFlow =
          !registrationType ||
          !IS_MULTI_SIGNATORY_ENABLED ||
          !isMultiSignatoryFlow(steps);

        const isPostSubmission = isPostSubmissionStatus(currentStatus);

        if (
          !isIndividualFlow &&
          currentStatus &&
          (BUSINESS_ONBOARDING_STATUSES.has(currentStatus) || isPostSubmission)
        ) {
          navigateTo(BUSINESS_VERIFICATION, {
            state: {
              registrationType,
              registrationSteps: steps,
              submitted: isPostSubmission,
            },
          });
          return;
        }

        navigateTo(SIGN_UP_USER, {
          state: { signupType: steps, registrationType },
        });
      }
    } catch (error: any) {
      console.error(error);
    }
  };

  return {
    getBusinessRegistrationType,
  };
};
